import { render } from "./_form-password2.vue?vue&type=template&id=285a4800"
import script from "./_form-password2.vue?vue&type=script&lang=js"
export * from "./_form-password2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__